<template>
  <div class="top">
      <span
        class="top-button is-right manual"
        style="color: #fff"
        @click="goToCockpit"
      >
        驾驶舱
      </span>
      <div class="top-line iconColor">|</div>
    <el-tooltip
      class="item"
      effect="dark"
      content="切换公司"
      placement="bottom"
    >
      <span class="top-text text-company" @click="handleChooseCompany"
        ><i class="el-icon-office-building" style="margin-right:5px;"></i
        >{{ userInfo.companyName }}
      </span>
    </el-tooltip>
    <div class="top-line iconColor">|</div>
    <span class="top-text">{{ userInfo.name }}</span>
    <div class="top-line iconColor">|</div>
    <div class="top-button is-right">
      <el-tooltip
        class="item"
        effect="dark"
        content="返回首页"
        placement="bottom"
      >
        <span>
          <fa
            class="iconColor"
            icon="home"
            @click="backIndex"
            style="color: #499ddb;cursor: pointer"
          ></fa>
        </span>
      </el-tooltip>
      <div class="top-line iconColor">|</div>
      <span
        class="top-button is-right manual"
        style="color: #fff"
        @click="prompt"
      >
        <i class="el-icon-document" style="margin-right: 5px"></i>
        操作手册
      </span>
      <div class="top-line iconColor">|</div>
    
      <el-badge
        :value="notifyLength"
        @click.native="showNotify"
        style="line-height: 24px"
      >
        <a
          @click.stop="showNotify"
          class="el-icon-message-solid"
          style="text-decoration: none"
          href="javascript:void(0)"
        ></a>
      </el-badge>
      <div class="top-line iconColor">|</div>
      <el-tooltip
        class="item"
        effect="dark"
        content="退出系统"
        placement="bottom"
      >
        <span>
          <fa
            class="iconColor"
            icon="sign-out-alt"
            @click="logout"
            style="color: #499ddb;cursor: pointer"
          ></fa>
        </span>
      </el-tooltip>
      <div class="top-line iconColor">|</div>
      <el-tooltip
        class="item"
        effect="dark"
        :content="isFullscreen ? '退出全屏' : '全屏'"
        placement="bottom"
      >
        <span class="top-item">
          <a @click="handleScreen">
            <fa
              class="iconColor"
              :icon="isFullscreen ? 'expand-arrows-alt' : 'expand-arrows-alt'"
              style="color: #499ddb;cursor: pointer"
            ></fa>
          </a>
        </span>
      </el-tooltip>
    </div>
    <el-dialog
      class="message-dialog"
      :append-to-body="true"
      title="待办事项"
      :visible.sync="vis_notify"
    >
      <el-table height="500px" :data="cachedNotify" :row-class-name="tableRowClassName">
        <el-table-column label="事项名称">
          <template v-slot="{ row }">
            <el-button @click="jumpTodo(row)" type="text">{{
              row.title
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="内容" prop="reason"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import store from "@/store";
import topLock from "./top-lock";
import topMenu from "./top-menu";
import LoginApi from "@/api/LoginApi";
import screenfull from "screenfull";
import auth from "../../../util/auth";
import encipherUtil from "../../../util/encipher";
import loginService from "@/login/api/login.service";
export default {
  components: {},
  name: "top",
  data() {
    return {
      appName: "",
      comName: "",
      perName: "",
      screenfull: screenfull,
      cachedNotify: [],
      infoId: "", // 当前登录人id
      regVisible: false,
      vis_notify: false, //通知是否展示
      userInfos: {},
      notifys: [],
      isShowChangeThemeDialog: false, //控制更换主题弹窗是否显示
      isFullscreen: false, //控制是否全屏
      notifyLength: 0
    };
  },
  watch: {
    appName: function(val) {
      return val;
    },
    isFullscreen(newV) {
      this.setFullscreen(newV);
    },
    "$route.name": function(v) {
      if (v === "indexPage") {
        let loginApi = new LoginApi();
        loginApi.getNotify().then(res => {
          this.notifys = res.data;
          this.notifyLength = this.notifys.length ? this.notifys.length - 1 : 0;
          if (this.notifys.length) {
            this.showNotify();
          }
        });
      }
    }
  },
  filters: {},
  created() {
    let encipher = new encipherUtil();
    //每次初始化该页面时，重新加载个人可以访问的菜单及路由
    // this.appName = this.$store.user.menu[0].name
    encipher.setLocalStorageAES("isFullscreen", "N");
    if (screenfull.isEnabled) {
      screenfull.on("change", () => {
        this.isFullscreen = screenfull.isFullscreen;
      });
    }
    let loginApi = new LoginApi();
    //获取该用户信息
    // let userParam = {}
    // loginApi.getUserInfo(userParam).then(res => {
    //     console.log(res.data, "res.data", "在这里也获取了用户信息")

    //     this.comName = res.data.company[0].name
    //     this.perName = res.data.userInfo.name
    //     this.infoId = res.data.userInfo.infoId
    //     //存储该用户在该应用下的菜单
    //     this.$store.dispatch("setUserInfo", res.data)
    //     this.$store.dispatch("setCurrentCompany", res.companyId)
    // })
    loginApi.getNotify({ pageSize: 1, pageNo: 1 }).then(res => {
      this.notifys = res.data;
      this.notifyLength = this.notifys.length ? this.notifys.length - 1 : 0;
      if (this.notifys.length && this.$route.name === "indexPage") {
        this.showNotify();
      }
    });
  },
  computed: {
    ...mapGetters(["userInfo", "tagWel", "tagList", "isCollapse", "tag"])
  },
  methods: {
    tableRowClassName({ row }) {
      if ((row.type === 1 || row.type === 2) && Number(row.days) >= 30) {
        return "background-color-row";
      }
      return "";
    },
    ...mapActions({
      setFullscreen: "form/setFullscreen"
    }),
    prompt() {
      window.open(
        "/share-foreign/ngFile/cncec-foreign-doc/index.html?token=" +
          store.getters.token,
        "_blank"
      );
    },
    goToCockpit() {
      this.$router.push({ path: "/cockpit" });
    },
    jumpTodo(row) {
      switch (row.type) {
        case 1:
          // 跳转立项详情
          var { href } = this.$router.resolve({
            path: "/set_up/company_setup",
            query: { itemInfoId: row.bizId }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 2:
          var { href } = this.$router.resolve({
            path: "/foreign_Invitation_manage/Invitation_report",
            query: { inviApplyId: row.bizId }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 3:
          // 注销护照
          var { href } = this.$router.resolve({
            path: "/exchange/company_cancel",
            query: { id: row.bizId }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 4:
          // 换发护照
          var { href } = this.$router.resolve({
            path: "/exchange/company_exchange",
            query: { id: row.bizId }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 5:
          // usbKey管理
          var { href } = this.$router.resolve({
            path: "/foreign_licence_manage/usb_key"
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 6:
          // 集团审核第三国备案
          var { href } = this.$router.resolve({
            path: "/foreign_record/company_clique"
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 7:
          // 前往第三国填报备案
          var { href } = this.$router.resolve({
            path: "/foreign_record/company_approve"
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 8:
          // 集团审核备案
          var { href } = this.$router.resolve({
            path: "/foreign_record/corporation_record_list"
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 9:
          let title = row.title;
          let index = title.lastIndexOf(")");
          let missiveTitle = title.substring(index + 1, title.length);
          // 公函管理 审核中
          var { href } = this.$router.resolve({
            path: "/system_management/letter_management",
            query: { missiveTitle: missiveTitle }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 10:
          // 公函管理 审核失败
          var { href } = this.$router.resolve({
            path: "/system_management/letter_management",
            query: { status: 4 }
          });
          this.vis_notify = false;
          window.open(href);
          break;
        case 11:
          // 跳转立项详情，二级企业填写成行情况
          var { href } = this.$router.resolve({
            path: "/set_up/company_setup",
            query: { itemInfoId: row.bizId }
          });
          this.vis_notify = false;
          window.open(href);
          break;
          case 12:
          // 跳转出行计划管理的详情页面
          var { href } = this.$router.resolve({
            path: "/foreign/visit_plan_manage_detail",
            query: { id: row.bizId,type:0 }
          });
          this.vis_notify = false;
          window.open(href);
          break;
          case 13:
          // 跳转出行计划增补管理的详情页面
          var { href } = this.$router.resolve({
            path: "/foreign/visit_plan_manage_detail",
            query: { id: row.bizId,type:1 }
          });
          this.vis_notify = false;
          window.open(href);
          break;
          // case 14:
          // // 跳转换发注销管理详情的页面
          // var { href } = this.$router.resolve({
          //   path: "/exchange/exchange_write",
          //   query: {
          //     id: row.bizId,
          //     from: '/exchange/corporation_exchange',
          //     type: "change",
          //     status: '70',
          //     renewalId: row.bizId
          //   }
          // });
          // this.vis_notify = false;
          // window.open(href);
          // break;
          case 14:
          // 跳转证照管理页面
          var { href } = this.$router.resolve({
            path: "/foreign_licence_manage/system_licence_manage",
            query: {}
          });
          this.vis_notify = false;
          window.open(href);
          break;
      }
    },
    handleChooseCompany() {
      this.$router.push({
        path: "/choose_company",
        query: { isChoose: "true" }
      });
    },
    showNotify() {
      this.cachedNotify = this.notifys.slice(1);
      if (this.cachedNotify.length) {
        this.vis_notify = true;
      }
    },
    Closes() {
      this.regVisible = false;
    },
    handleScreen() {
      let encipher = new encipherUtil();
      if (!screenfull.isEnabled) {
        this.$message({
          message: "你的浏览器不支持全屏",
          type: "warning"
        });
        return false;
      }
      screenfull.toggle();
      if (!this.isFullscreen) {
        encipher.setLocalStorageAES("isFullscreen", "Y");
      } else {
        encipher.setLocalStorageAES("isFullscreen", "N");
      }
    },
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    setScreen() {
      this.$store.commit("SET_FULLSCREN");
    },
    handleCommand(command) {
      if (command == "caozuoshouce") {
      }
    },
    //更换主题
    handleTheme() {
      this.isShowChangeThemeDialog = true;
    },
    //关闭更换主题弹窗
    closeThemeDialog() {
      this.isShowChangeThemeDialog = false;
    },
    logout() {
      this.$confirm("是否退出系统, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        loginService.logout().then(res => {
          // window.sessionStorage.removeItem('fuPicFlag')
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearLock");
          this.$store.dispatch("clearTag");
          // //退出时清空纠纷管理中路由之间保存的信息
          // this.$store.commit('SET_DISPUTESMESSAGE', {})
          // this.$store.commit('SET_MENU', null);
          sessionStorage.removeItem("appTempId");
          sessionStorage.removeItem("newPagePath");
          localStorage.removeItem("token");
          auth.removeToken();
        });
        // let loginApi = new LoginApi();
        // let params = { token: store.getters.token };
        // loginApi.logout(params).then(res => {
        //   this.$store.dispatch("clearToken");
        //   this.$store.dispatch("clearLock");
        //   this.$store.dispatch("clearTag");
        //   sessionStorage.removeItem('appTempId');
        //   sessionStorage.removeItem('newPagePath');
        //   localStorage.removeItem("token")
        //   auth.removeToken()
        //   let logOutUrl = window.location.href.split("#")[0] + "#/login";
        //   window.location.href = `${
        //     process.env.SSO_HOST
        //   }/ibs/loginOut?redirectUrl=${encodeURIComponent(logOutUrl)}&appId=${
        //     process.env.SSO_APP_ID
        //   }`;
        // });
      });
    },
    backIndex() {
      this.$router.push({ path: "/index" });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-table ::v-deep .background-color-row {
  background: #ffe0b2;
}
@media screen and (max-device-width: 1366px) {
  .top-fonts {
    font-size: 16px;
    margin-left: 60px;
  }
  .tags-breadcrumb {
    padding: 0px;
  }
}
.text-company {
  cursor: pointer;
}
.manual {
  text-decoration: none;
  cursor: pointer;
}
.message-dialog {
  height: 80%;
  overflow: hidden;
}
</style>
